<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <router-link :to="{ name: 'tambahTarifVoucher'}"  class="btn btn-primary"  v-if="myGlobal.RootOnly()">Tambah Tarif Voucher</router-link>
        </div>
      </div>
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-6">
                    <h4 class="card-title ">Daftar Tarif Voucher</h4>
                    <p class="card-category">Berikut daftar Tarif Voucher anda</p>
                  </div>
                  <div class="col-md-6" v-show="false">
                    <h2 class="card-title text-right">{{data.filtered}}</h2>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Mikrotik</th>
                      <th>Harga Jual</th>
                      <th>Harga Beli</th>
                      <th></th>
                    </thead>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{ u.nama }}</br> <span class="text-secondary">Profil : {{ u.profile }}</span></br><span class="text-secondary">Ket : {{ u.keterangan }}</span></td>
                        <td>{{ u.mnama }}</td>
                        <td>{{ ribu(u.harga) }}</td>
                        <td>{{ ribu(u.harga_beli) }}</td>
                        <td>
                          
                          <button v-show="isAllow()" class="btn btn-sm btn-info" @click="
                          update.data.modalEdit = true, 
                          update.data.idtarif = u.id,
                          update.data.namaTarif = u.nama,
                          update.data.harga = u.harga,
                          update.data.keterangan = u.keterangan,
                          update.data.profil = u.profile,
                          update.data.mikrotik = u.mnama
                          "><i class="material-icons">edit</i> Edit</button>
                        </td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          
      </div>

      <!-- MODAL -->
      <div class="modal" tabindex="-1" role="dialog" v-show="update.data.modalEdit">
        <div class="overlay"></div>
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Edit Tarif Voucher</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="update.data.modalEdit = false">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <div class="form-group">
                      <label class="bmd-label-floating">Nama Paket</label>
                      <input type="text" class="form-control" placeholder="Nama Paket..." v-model="update.data.namaTarif">  
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">Harga</label>
                      <input type="number" class="form-control" placeholder="Tarif..." v-model="update.data.harga"> 
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">Keterangan</label>
                      <input type="text" class="form-control" placeholder="Keterangan..." v-model="update.data.keterangan"> 
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">User Profil Mikrotik</label>
                      <p  class="form-control mb-0" placeholder="Keterangan..." v-text="update.data.profil"></p>
                    </div>
                    <div class="form-group">
                      <label class="bmd-label-floating">Mikrotik</label>
                      <p  class="form-control mb-0" placeholder="Mikroitk..." v-text="update.data.mikrotik"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="update.hapus()">Hapus</button>
              <button type="button" class="btn btn-secondary" @click="update.cancel()">Cancel</button>
              <button type="button" class="btn btn-success" @click="update.submit()">Simpan</button>
            </div>
          </div>
        </div>
      </div>


    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
  name: 'Beranda',
  components: { 

  }, 
  setup() {
		const data = reactive({
      filtered: '',

      /* modal edit tarif */
    })

		const theGet = {
      data: reactive({
        List: [],
      }),
			datae() {
				var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken')
        };
				//datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				//datax.append('id', data.params.id);
				
				var apiUrl = inter.tarif();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						this.data.List = x.data;
					} else {
						//alert(x.pesan);
					}
				})
			}
    }
    const update = {
      data: reactive({
        modalEdit: '',
        idtarif: '',
        namaTarif: '',
        harga: '',
        keterangan: '',
        profil: '',
        mikrotik: ''
      }),
			cancel() {
        this.data.modalEdit = false;
      },
			hapus() {
				var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          id: this.data.idtarif
        };
				
				var apiUrl = inter.tarifHapus();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						this.cancel();
            theGet.datae();
					} else {
						//alert(x.pesan);
					}
				})
      },
			submit() {
				var datax = {
          token: 'TangTung '+sessionStorage.getItem('myToken'),
          nama: this.data.namaTarif,
          harga: this.data.harga,
          ket: this.data.keterangan,
          id: this.data.idtarif
        };
				
				var apiUrl = inter.tarifUpdate();
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == true) {
						this.cancel();
            theGet.datae();
					} else {
						//alert(x.pesan);
					}
				})
			}
    }
    return {
      data, 
      theGet,
      update,
      myGlobal
    }

  },
  mounted () {
    document.title = "Daftar Tarif Voucher";

    this.theGet.datae();
  }
}

  /*
  name: 'Beranda', 
  components: { 
    vuejsDatepicker,
    moment,
    'barcode': VueBarcode
  },
  data () {
    return {
      area: [],

      filtered: '',
      
      modalEdit: false,
      idPaket: '',
      namaPaket: '',
      tarifPaket: '',

    }
  },
  methods: {
    Simpan() {
      var data = new FormData();

      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('id', this.idPaket);
      data.append('nama', this.namaPaket);
      data.append('tarif', this.tarifPaket);
      
      var apiUrl = 'EditTarif';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.modalEdit = false;
          this.getData();
        } else {
          this.textSalah = x.pesan;
        }
      })
    },
    getData() {
      this.isCari = false;
      var data = new FormData();
      data.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
      data.append('type', "all");
      data.append('bulan', "0");
      
      var apiUrl = 'ListPaket';
      this.PostData(data,apiUrl).then(x => {
        if (x.status) {
          this.area = x.data;
        } else {
          //alert(x.pesan);
        }
      })
    }
  },
  */
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/voucher/tarif.vue